import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { CookieService } from 'ngx-cookie-service';
import { DataService } from './../../../services/data/data.service';
import { FuncionesMes, formatear, periodosOperativo} from './../../funciones/funcionesGenerales';
import { AnalisisEventosPotService } from '../../../services/operative-potential/analisis-eventos-pot/analisis-eventos-pot.service';
import { companies } from '../../../shared/catalogos';
import { ExcelService } from '../../../services/excel/excel.service';
import { IMG } from '../../../services/imagen/png';

import moment from 'moment';
import Swal from 'sweetalert2';
import ApexCharts from 'apexcharts';
import { firstValueFrom, forkJoin } from 'rxjs';

@Component({
  selector: 'app-analisis-eventos',
  templateUrl: './analisis-eventos.component.html',
  styleUrl: './analisis-eventos.component.css'
})
export class AnalisisEventosComponent {
//---------------VARIABLES GENERALES
  private errorMessage = '<br/><br/><div> <span style="text-aling: center;font-size: 10pt;font-weight: 200;">Precione</span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 600;"> esc </span>'+
  '<span style="text-aling: center;font-size: 10pt;font-weight: 200;">para cerrar</span></div>';
  public colorMulti: any = ['#2843A0','#15A075','#36CAE8','#78EAD2','#F88476','#E23E6A'];
  public colorMono: any = ['#76C4D5'];
  //-------------VARIABLES OBTENCION DE PERIODOS
  private numEvaluaciones = 1;
  public Periodos = [];
  public Periodos2 = [];
  /*Titulos y subtitulos*/
  public subTitles = '';
  public subTitles2 = '';
  /*Filtros*/
  public cadenaEvaluacion = [];
  public cadenaEvaluacion2 = [];

  //----------VARIABLES DEL TABLERO
  public perspectivas = [];
  public encPers = '';
  public encMet = 1;
  public dataOrdenado = [];
  public reportes = [];
  private reportesAll = [];

  private nivelRiesgo = [];
  private nivelExpocision = [];
  private controlValores = [];

  //grafica
  public options: any = {};
  public chart;
  public chart2;
  public renderGrafica = false;
  public chartAmp;
  public tituloModal = '';
  public tipoGraf = 'bar';

  public suffix = 'MXN';
  public miles = ',';
  public decimal = '.';

  public filtroPeriodos = false;
  public niveles = 3;


  private catalogos = [
    {name: 'Control', cat: []},
    {name: 'Fuente', cat: []},
    {name: 'Impacto', cat: []},
    {name: 'Perdida', cat: []},
    {name: 'Probabilidad', cat: []},
    {name: 'Riesgo', cat: []},
    {name: 'Área', cat: []}
  ];
  private nivelriesgocat = [];
  private nivelexpocisioncat = [];
  private controlvalcat = [];
  private categoria = [];
  public catalogosLLen = [];
  private idInstitucion = '';

  constructor(
    public dataService: DataService,
    private translate: TranslateService,
    private cookieService: CookieService,
    private exportExcel: ExcelService,
    private service: AnalisisEventosPotService,
  ) {
    this.idInstitucion = this.cookieService.get('idInstitucion');
    const ex = companies.find(i => i.id === this.idInstitucion);
    this.suffix = ex.suffix;
    this.startCatalogs();
  }
  private async startCatalogs(){
    const catalogos = [
      'efectividadcontrol',
      'fuente',
      'impacto',
      'perdida',
      'probabilidad',
      'riesgo',
      'area',
      'categoria',
      'nivelexpocision',
      'nivelriesgo',
      'controlval'
    ] as const;

    const data = await firstValueFrom(
      forkJoin(
        Object.fromEntries(
          catalogos.map(tipo => [
            tipo,
            this.service.getCatalogos(this.idInstitucion, tipo),
          ]),
        ),
      ),
    );
    this.catalogos[0].cat = [].concat(data['efectividadcontrol']);
    this.catalogos[1].cat = [].concat(data['fuente']);
    this.catalogos[2].cat = [].concat(data['impacto']);
    this.catalogos[3].cat = [].concat(data['perdida']);
    this.catalogos[4].cat = [].concat(data['probabilidad']);
    this.catalogos[5].cat = [].concat(data['riesgo']);
    this.catalogos[6].cat = [].concat(data['area']);
    this.categoria = [].concat(data['categoria']);
    this.nivelexpocisioncat = [].concat(data['nivelexpocision']);
    this.nivelriesgocat = [].concat(data['nivelriesgo']);
    this.controlvalcat = [].concat(data['controlval']);
    this.getEvaluacion();
  }

  ngOnInit(): void {
  }
  /* Mensaje de error consultas */
  private errorMesage(err){
    var errores = ''
    for(const er of err.message){
      errores += er +'<br>'
    }
    var texto = errores + this.errorMessage;

      Swal.fire({
        html: texto,
        icon: 'error',
        showCancelButton: false,
        showConfirmButton: false,
      });
  }
  ///----------FUNCIONES OBTENCION DE PERIODOS 
  //obtencion de periodos
  private getEvaluacion(){
    this.obtCatalogos();
  }
  private ordenamientoDataEvaluacion() {
    const iniDate = this.reportesAll.map( i => moment(i.event_date) ).sort( (a, b) => a.diff(b))[0];
    
    const fecha = moment();
    this.Periodos = periodosOperativo.obtenerPeriodosFechas(fecha, iniDate);
    this.Periodos[this.Periodos.length-1].series[this.Periodos[this.Periodos.length-1].series.length-1].check = false;
    this.Periodos[0].series[0].check = true;
    this.Periodos2 = periodosOperativo.obtenerPeriodosFechas(fecha, iniDate);
    this.obtenerDataEvaluacion();
  }
  /* Obtención de periodos */
  private obtenerDataEvaluacion(){
    this.cadenaEvaluacion = [];
    this.cadenaEvaluacion2 = [];
    this.subTitles = "";
    this.subTitles2 = "";
    var tot=0;
    for(var i = this.Periodos.length-1; i>=0; i--){
      for(var j = this.Periodos[i].series.length-1; j>=0; j--){
        if(this.Periodos[i].series[j].check || (tot>0 && tot<12)){
          this.cadenaEvaluacion.push({
            evaluacion: this.Periodos[i].series[j].periodo,
            idEvaluacion: this.Periodos[i].series[j].id,
            porcentaje: '%',
            pos: this.Periodos[i].series[j].pos,
            periodo: this.Periodos[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos[i].series[j].mes)
          });
          tot++;
        }
      }
    }
    for(var i = this.Periodos2.length-1; i>=0; i--){
      for(var j = this.Periodos2[i].series.length-1; j>=0; j--){
        if(this.Periodos2[i].series[j].check || (tot>0 && tot<12)){
          this.cadenaEvaluacion2.push({
            evaluacion: this.Periodos2[i].series[j].periodo,
            idEvaluacion: this.Periodos2[i].series[j].id,
            porcentaje: '%',
            pos: this.Periodos2[i].series[j].pos,
            periodo: this.Periodos2[i].series[j].an + '-' + FuncionesMes.f_switchmes3(this.Periodos2[i].series[j].mes)
          });
          tot++;
        }
      }
    }
    this.subTitles = this.cadenaEvaluacion[0].evaluacion;
    this.subTitles2 = this.cadenaEvaluacion2[0].evaluacion;
    var check = false, contador = 0;
    for(let i = 0; i < this.Periodos.length; i++){
      for(let j = 0; j < this.Periodos[i].series.length; j++){
        if(this.Periodos[i].series[j].check || check){
          this.Periodos2[i].series[j].visible = true;
          check = true;
        }else{
          this.Periodos2[i].series[j].visible = false;
        }
        if(this.Periodos2[i].series[j].visible){
          contador++;
        }
      }
      if(contador == 0){
        this.Periodos2[i].visible = false;
      }
    }
    this.selecCategoriaFilter();
  }
  /* formateo de datos */
  public escrituraPeriodo(Periodo){
    if(Periodo.split(' ').length === 2){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }else if(Periodo.split(' ').length === 5){
      const datos = Periodo.split(' ');
      return this.translate.instant('filtros.'+datos[0])+' '+datos[1]+' '+datos[2]+' '+this.translate.instant('filtros.'+datos[0])+' '+datos[1];
    }
    return Periodo;
  }
  //Filtro Periodo
  ///funcion para select periodo
  public cambioPeriodo(per, rango){
    if(rango == 'inicio'){
      for(const an of this.Periodos){
        for(const mes of an.series){
          if(mes.periodo === per.periodo){
            mes.check = true;
          }else{
            mes.check = false;
          }
        }
      }
      var check = false, contador = 0, selec2 = 0, posAn = 0, posMes = 0;
      for(let i = 0; i < this.Periodos.length; i++){
        for(let j = 0; j < this.Periodos[i].series.length; j++){
          if(this.Periodos[i].series[j].check || check){
            this.Periodos2[i].series[j].visible = true;
            if(!check){
              posAn = i;
              posMes = j;
            }
            check = true;
          }else{
            this.Periodos2[i].series[j].visible = false;
            this.Periodos2[i].series[j].check = false;
          }
          if(this.Periodos2[i].series[j].visible){
            contador++;
          }
          if(this.Periodos2[i].series[j].check){
            selec2++;
          }
        }
        if(contador == 0){
          this.Periodos2[i].visible = false;
        }else{
          this.Periodos2[i].visible = true;
        }
      }
      if(selec2 === 0){
        this.Periodos2[posAn].series[posMes].check = true;
      }
    }
    if(rango == 'fin'){
      for(const an of this.Periodos2){
        for(const mes of an.series){
          if(mes.periodo === per.periodo){
            mes.check = true;
          }else{
            mes.check = false;
          }
        }
      }
    }
    
    this.obtenerDataEvaluacion();
  }
  //metodo para el calculo de los periodos seleccionables para el mes fin
  public periodosFin(){
    this.Periodos2
    
  }
  //filtro perspectiva
  public cambioPerspectiva(i){
    this.encPers = i;
    this.selecCategoriaFilter();
  }
  //-------FUNCIONES DEL TABLERO 
  private obtCatalogos(){
    var i = 0, aux = [];
    for(const cat of this.catalogos){
      aux.push({
        nombre: cat.name,
        catalogo: cat.cat,
      });      
    }
    this.catalogosLLen = aux;

    var aux = [], auxCon = [], auxEven = [];
    for(const cat of this.categoria){
      if(cat.values.length !== 0){
        for(const con of cat.values){
          if(con.values.length!==0){
            for(const even of con.values){
              auxEven.push({
                nombre: even.name
              });
            }
          }
          auxCon.push({
            nombre: con.name,
            values: auxEven
          });
          auxEven = [];
        }
      }
      aux.push({
        name: cat.name,
        id: cat.id,
        values: auxCon,
      });
      auxCon = [];
    }

    let nombre = ' Categoria';
    this.catalogosLLen.push({
      nombre: nombre.substring(1),
      catalogo: aux,
    });

    this.catalogosLLen.sort(function (a, b) {
      if (a.nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "") > b.nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "")) {
        return 1;
      }
      if (a.nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "") < b.nombre.normalize("NFD").replace(/[\u0300-\u036f]/g, "")) {
        return -1;
      }
      return 0;
    });

    if(aux[0].values[0].values){
      this.niveles = 3;
    }else if(aux[0].values){
      this.niveles = 2;
    }

    this.nivelRiesgo = this.nivelriesgocat;
    this.nivelExpocision = this.nivelexpocisioncat;
    this.controlValores = this.controlvalcat;
    this.getPerspectivas();    
  }
  public getPerspectivas(){
    this.perspectivas = [];

    for(const cat of this.catalogosLLen){
      this.perspectivas.push(cat.nombre);
    }

    this.encPers = this.perspectivas[0];
    this.getReportes();
  }
  private getReportes(){
    this.reportes = [];
    this.reportesAll = [];
    let aux = [];
    this.service.getEventos().subscribe(response =>{
      const events = response['data'];
      var i = 0;
      for(const rep of events){
        if(rep.institution_id === this.idInstitucion){
          aux.push({
            institution_id: rep.institution_id,
            event_date: moment(rep.event_date.split('T')[0]).format("YYYY-MM-DD"),
            area: Number(rep.area),
            process: rep.process,
            risk_type: Number(rep.risk_type),
            categoria: Number(rep.category),
            concepto: Number(rep.concept),
            evento: Number(rep.event),
            fuente: Number(rep.source),
            riesgo: Number(rep.derived_risk),
            perdida: Number(rep.loss),
            impacto: Number(rep.impact),
            probabilidad: Number(rep.probability),
            control_type: Number(rep.control_type),
            periodicity: Number(rep.periodicity),
            opportunity: Number(rep.opportunity),
            control: Number(rep.control_effectiveness),
            id : i,
            idReporte: rep.id,
            select: false
          });
          i++;
        }
        
      }
      this.reportes = [].concat(aux);
      this.reportesAll = [].concat(aux);
      this.ordenamientoDataEvaluacion();
    }, error=>{
      this.errorMesage(error.error);
    });
  }
  private getData(){
    let aux = [];
    const cat = this.catalogosLLen.filter(cat => cat.nombre === this.encPers)[0]; 
    let val1 = 0, val2 = 0, val3 = 0, val4 = 0, val5 = 0, val6 = 0;
    if(cat !== undefined){
      let prop = this.encPers.split(' ')[0].split('/')[0].toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      for(const c of cat.catalogo){
        const datos = this.reportes.filter( r => r[''+prop] === c.id); 
        
        let numRie = 0, numExp = 0;
        datos.forEach( inf =>{
          const riesgoImp = inf.probabilidad * inf.impacto;

          var cat = this.catalogosLLen.filter(cat => cat.nombre === 'Control')[0].catalogo;
          var n =  cat.find(item => item.id === inf.control).name;
          var valCont = this.controlValores.find( val => val.name === n ).id/100;

          const nivelExp = riesgoImp*valCont;
          numRie += riesgoImp;
          numExp += nivelExp;
        });
                
        let rieRie = 0, rieExp = 0;
        if(numRie !== 0&& numExp !== 0){
          rieRie = Number((numRie/datos.length).toFixed(2));
          rieExp = Number((numExp/datos.length).toFixed(2));
        }

        const textoRie = this.nivelRiesgo.filter( n => n.min <= rieRie && n.max >= rieRie)[0].name;
        const textoExp = this.nivelExpocision.filter( n => n.min <= rieExp && n.max >= rieExp)[0].name;

        val1 += datos.length;
        val2 += Number((datos.length*100/this.reportes.length).toFixed(2));
        val3 += rieRie;
        val5 += rieExp;

        aux.push({
          categoria: c.name,
          numEven: datos.length,
          porEven: Number((datos.length*100/this.reportes.length).toFixed(2)),
          numRies: rieRie,
          nivRies: textoRie,
          numExp: rieExp,
          nivExp: textoExp
        });
      }

      let textval4 =  this.nivelRiesgo.filter( n => n.min <= Number((val3/cat.catalogo.length).toFixed(2)) && n.max >= Number((val3/cat.catalogo.length).toFixed(2)) )[0].name;
      let textval6 =  this.nivelExpocision.filter( n => n.min <= Number((val5/cat.catalogo.length).toFixed(2)) && n.max >= Number((val5/cat.catalogo.length).toFixed(2)) )[0].name;

      aux.push({
        categoria: 'Total general',
        numEven: Number(val1.toFixed(0)),
        porEven: Number(val2.toFixed(0)),
        numRies: Number((val3/cat.catalogo.length).toFixed(2)),
        nivRies: textval4,
        numExp: Number((val5/cat.catalogo.length).toFixed(2)),
        nivExp: textval6
      });

      this.dataOrdenado = [].concat(aux);
      this.grafica(this.tipoGraf);
    }
    
  }
  public cambioMetrica(metrica ){
    if(metrica == 'riesgo'){
      this.encMet = 1;
      this.grafica(this.tipoGraf);
    }else{
      this.encMet = 2;
      this.grafica(this.tipoGraf);
    }
  }
  //Dar color de fondo a la celda en base a los puntos de riesgo
  public pintarNivelRiesgo(num){
    const texto = this.nivelRiesgo.filter( n => n.min <= num && n.max >= num)[0].name;

    switch(texto){
      case 'Tolerable': return "w3-border-verde";
      case 'Moderado': return "w3-border-amarillo";
      case 'Relevante': return "w3-border-naranja";
      case 'Inaceptable': return "w3-border-rojo";
    }

    return "";
  }
  //Dar color de fondo a la celda en base a los puntos de exposicion
  public pintarNivelExp(num){
    const texto = this.nivelExpocision.filter( n => n.min <= num && n.max >= num)[0].name;

    switch(texto){
      case 'Muy bajo': return "w3-border-verde";
      case 'Bajo': return "w3-border-verdeBajo";
      case 'Medio': return "w3-border-amarillo";
      case 'Alto': return "w3-border-naranja";
      case 'Muy Alto': return "w3-border-rojo";
    }

    return "";
  }
  //genera la grafica de acuerdo a los datos
  public grafica(tipo){
    this.tipoGraf = tipo;
    var cantidades = [];
    var etiquetas = [];
    var data = [];

    for(let i = 0; i < this.dataOrdenado.length-1; i++){
      if(this.dataOrdenado[i].numEven){
        cantidades.push(this.encMet == 1 ? this.dataOrdenado[i].numRies : this.dataOrdenado[i].numExp);
        etiquetas.push(this.dataOrdenado[i].categoria);
      }
    }
    data.push({
      name: '',
      data: cantidades
    });

    this.options = {
      chart: {
        width: "100%",
        height: "100%",
        type: tipo,
        toolbar: {
          show: false
        },
        animations: {
          enabled: true,
          easing: 'easeinout',
          speed: 400,
          animateGradually: {
              enabled: false,
          },
          dynamicAnimation: {
              enabled: false,
          }
        },
        zoom: {
          enabled: false
        }
      },
      plotOptions:{
        bar:{
          horizontal: false,
        }
      },
      colors: this.colorMono,
      fill:{
        opacity: 0.7
      },
      dataLabels: {
        enabled: false
      },
      series: data,
      xaxis: {
        categories: etiquetas,
        labels: {
          maxHeight: 80,
          trim: true
        },
        tooltip: {
          enabled: false,
        }
      },
      yaxis: {
        style: {
          fontSize: '12px',
          fontFamily: 'Roboto',
          fontWeight: 600,
        },
        labels: {
          formatter: (value) => { 
            var val = formatear.retornarformatolefty(value);
            var dat = val.split(' ');
            return  formatear.retornarformatoval(dat[0],dat[1],dat[2], this.miles, this.decimal);
          },
        }
      },
      tooltip:{
        enabled: true,
        theme: "dark",
        z:{
          formatter: undefined,
          title: 'Eventos'
        }
      },
      grid: {
        show: false
      },
      markers: {
        size: 6,
        hover: {
          size: 6
        },
        fillOpacity: 1
      },
      stroke:{
        show: true,
        curve: "smooth"
      },

    };
    this.options.dataLabels.enabled = this.labelsGrafica;

    if(this.renderGrafica){
      this.chart.destroy();
    }
    setTimeout(() =>{  
      this.chart = new ApexCharts(
        document.querySelector("#grafica"),//id del div 
        this.options
      );
      this.chart.render();
      this.renderGrafica = true;
      this.options.stroke["show"] = true;
    }, 100);
  }
  
  labelsGrafica;
  public etiquetasGraf1(labels){
    this.labelsGrafica = labels;
    if(this.renderGrafica){
      this.chart.destroy();
    }

    this.options.dataLabels.enabled = this.labelsGrafica;

    setTimeout(() =>{  
      this.chart = new ApexCharts(
        document.querySelector("#grafica"),//id del div 
        this.options
      );
      this.chart.render();
      this.renderGrafica = true;
      this.options.stroke["show"] = true;
    }, 100);
  }
  //ampliar la grafica 
  public ampliarGraf(){
    document.getElementById("ampliar")!.style.display = "block";
    setTimeout(() =>{  
      this.chart2 = new ApexCharts(
        document.querySelector("#graficaAmpliada"),//id del div 
        this.options
      );
      this.chart2.render();
    }, 100);
  }
  //Cerrar modal ampliar grafica
  public closeModal(){
    this.chart2.destroy();
    document.getElementById("ampliar")!.style.display = "none";
  }
  //detecta el click fuera del modal y cierra 
  public clickFuera(event){
    if (event.target === document.getElementById("ampliar")) {
      this.closeModal();
    }
  }
  //genera la tabla en formato excel
  public exportarExcel(){
    var titulos = [], encabezados = [], datos = [];

    titulos.push("");
    titulos.push(this.translate.instant('operative.analisis.titulo2'));
    titulos.push("");
    titulos.push(this.translate.instant('operative.analisis.titulo3'));
    titulos.push("");
    titulos.push(this.translate.instant('operative.analisis.titulo4'));
    titulos.push("");
    encabezados.push(this.translate.instant('operative.analisis.titulo1'));
    encabezados.push(this.translate.instant('operative.analisis.encabezado1'));
    encabezados.push("%");
    encabezados.push(this.translate.instant('operative.analisis.encabezado2'));
    encabezados.push(this.translate.instant('operative.analisis.encabezado3'));
    encabezados.push(this.translate.instant('operative.analisis.encabezado2'));
    encabezados.push(this.translate.instant('operative.analisis.encabezado3'));
  
    for(const i of this.dataOrdenado){
      var aux = [];
      aux.push(i.categoria);
      aux.push(i.numEven);
      aux.push(i.porEven/100);
      aux.push(i.numRies);
      aux.push(i.nivRies);
      aux.push(i.numExp);
      aux.push(i.nivExp);
      datos.push(aux);
    }

    let tituloHoja = this.translate.instant('operative.analisis.tituloTabla') + this.encPers.toLowerCase() + " | " + this.escrituraPeriodo(this.subTitles2);
    this.exportExcel.excelOperativoAnalisis(tituloHoja,titulos,encabezados,datos,this.translate.instant('operative.analisis.tituloTabla') + this.encPers.toLowerCase() + " " + this.escrituraPeriodo(this.subTitles2));
  }
  //genera la grafica en formato de imagen
  public exportarGrafica(id, nombre, nombre2){
    IMG.exportimagenes(id, this.translate.instant(nombre) + " " + nombre2 + " "  + this.escrituraPeriodo(this.subTitles2))
  }
  /* Filtros */
  public activacionFiltros(){
    this.filtroPeriodos = !this.filtroPeriodos;
    this.selecCategoriaFilter();
  }
  public selecCategoriaFilter(){
    if(this.reportesAll.length !== 0){
      let aux = [];
    
      aux = [].concat(this.reportesAll);

      if(this.filtroPeriodos){
        let aux2 = [];
        const fechaIni = moment(this.cadenaEvaluacion[0].periodo+'-01');
        const fechaFin = moment(this.cadenaEvaluacion2[0].periodo+'-01');
        for(const dat of aux){
          if(periodosOperativo.validacionPeriodo(moment(dat.event_date),fechaIni,fechaFin)){
            aux2.push(dat);
          }
        }
        aux = [].concat(aux2);
      }

      this.reportes = [].concat(aux);
      this.getData();
    }
  }
}
